export default async function CreateDropdownValueApi(planAttributeId, value, displayOrder) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify({
        planAttributeId,
        value,
        displayOrder,
      }),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plan-attributes/dropdown-values`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error creating dropdown value: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
